// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/plugins/v1/variable_service.proto (package mochabugapis.adapt.plugins.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { Value, ValueJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JTDSchema, JTDSchemaJson } from "../../graph/jtd_schema_pb";
import { file_mochabugapis_adapt_graph_jtd_schema } from "../../graph/jtd_schema_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/plugins/v1/variable_service.proto.
 */
export const file_mochabugapis_adapt_plugins_v1_variable_service: GenFile = /*@__PURE__*/
  fileDesc("CjRtb2NoYWJ1Z2FwaXMvYWRhcHQvcGx1Z2lucy92MS92YXJpYWJsZV9zZXJ2aWNlLnByb3RvEh1tb2NoYWJ1Z2FwaXMuYWRhcHQucGx1Z2lucy52MSKLAQoSVmFyaWFibGVEZWZpbml0aW9uEjsKBnNjaGVtYRgBIAEoCzIjLm1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC5KVERTY2hlbWFCBrpIA8gBARIsCgdkZWZhdWx0GAIgASgLMhYuZ29vZ2xlLnByb3RvYnVmLlZhbHVlSACIAQFCCgoIX2RlZmF1bHRiBnByb3RvMw", [file_buf_validate_validate, file_google_protobuf_struct, file_mochabugapis_adapt_graph_jtd_schema]);

/**
 * A definition of a JSON variable
 *
 * This message represents a variable used within the hosting platform.
 * Variables are essential for configuring applications and services hosted on the platform.
 * They store values that can be accessed by the application or service during runtime.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.VariableDefinition
 */
export type VariableDefinition = Message<"mochabugapis.adapt.plugins.v1.VariableDefinition"> & {
  /**
   * The schema that the variable must adhere to
   *
   * @generated from field: mochabugapis.adapt.graph.JTDSchema schema = 1;
   */
  schema?: JTDSchema;

  /**
   * The optional default value
   *
   * @generated from field: optional google.protobuf.Value default = 2;
   */
  default?: Value;
};

/**
 * A definition of a JSON variable
 *
 * This message represents a variable used within the hosting platform.
 * Variables are essential for configuring applications and services hosted on the platform.
 * They store values that can be accessed by the application or service during runtime.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.VariableDefinition
 */
export type VariableDefinitionJson = {
  /**
   * The schema that the variable must adhere to
   *
   * @generated from field: mochabugapis.adapt.graph.JTDSchema schema = 1;
   */
  schema?: JTDSchemaJson;

  /**
   * The optional default value
   *
   * @generated from field: optional google.protobuf.Value default = 2;
   */
  default?: ValueJson;
};

/**
 * Describes the message mochabugapis.adapt.plugins.v1.VariableDefinition.
 * Use `create(VariableDefinitionSchema)` to create a new message.
 */
export const VariableDefinitionSchema: GenMessage<VariableDefinition, VariableDefinitionJson> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_plugins_v1_variable_service, 0);

